import React from 'react';
import styled from 'styled-components';
import Avatar from 'react-avatar';

const UserAvatar = ({ userInfo, height, width }) => {
  if (userInfo?.picture) {
    return <img src={userInfo.picture} height={height} width={width} />;
  } else if (userInfo?.firstName) {
    return <Avatar name={`${userInfo.firstName} ${userInfo.lastName}`} size={width} round="100%" />;
  } else {
    return null;
  }
};

export default styled(UserAvatar)`
  border-radius: 100% !important;
`;
